import React from "react";
import { Route, Routes } from "react-router-dom";

import Sidenav from "examples/Sidenav";
import routes from "routes";
import ProtectedRoute from "./ProtectedRoute";
import AddNewJob from "AddViews/AddNewJob";
import UpdateJob from "UpdateViews/UpdateJob";
import JobWiseApplicants from "./Views/JobWiseApplicants";
import ApplicantProfile from "./Views/ApplicantProfile";
import AddNewTestimonial from "AddViews/AddTestimonials";
import UpdateTestimonials from "UpdateViews/UpdateTestimonials";
import AddCareer from "AddViews/AddCareer";
import AddExam from "AddViews/AddExam";
import AddExamList from "AddViews/AddExamList";
import AddExamListSet from "AddViews/AddExamListSet";
import AutoCreateExamListSets from "AddViews/AutoCreateExamListSets";
import AddYear from "AddViews/AddYear";
import UpdateCareer from "UpdateViews/UpdateCareer";
import UpdateExam from "UpdateViews/UpdateExam";
import UpdateExamList from "UpdateViews/UpdateExamList";
import UpdateExamListSet from "UpdateViews/UpdateExamListSet";
import UpdateYear from "UpdateViews/UpdateYear";
import AddTopics from "AddViews/AddTopics";
import UpdateTopics from "UpdateViews/UpdateTopicc";
import AddLevels from "AddViews/AddLevels";
import AddArLevels from "AddViews/AddArLevels";
import UpdateLevels from "UpdateViews/UpdateLevels";
import UpdateArLevels from "UpdateViews/UpdateArLevels";
import LevelQuestions from "./Views/LevelQuestions";
import UserDetails from "./Views/UserDetails";
import UserFeedback from "./Views/UserFeedback";
import AddUniversity from "AddViews/AddUniversity";
import AddEmployee from "AddViews/AddEmployee";
import UpdateUniversity from "UpdateViews/UpdateUniversity";
import UpdateEmployee from "UpdateViews/UpdateEmployee";
import AddQuestions from "AddViews/AddQuestions";
import BulkImportArQuestions from "AddViews/BulkImportArQuestions";
import BulkImportAgriBoost from "AddViews/BulkImportAgriBoost";
import BulkImportPreviousYearQuestions from "AddViews/BulkImportPreviousYearQuestions";
import AddAgriBoost from "AddViews/AddAgriBoost";
import AddPreviousYearQuestion from "AddViews/AddPreviousYearQuestion";
import AddPreviousYearDocument from "AddViews/AddPreviousYearDocument";
import ApproveQuestions from "./Views/ApproveQuestions";
import UpdateQuestions from "UpdateViews/UpdateQuestions";
import UpdateArQuestion from "UpdateViews/UpdateArQuestion";
import UpdateAgriBoost from "UpdateViews/UpdateAgriBoost";
import UpdatePreviousYearQuestion from "UpdateViews/UpdatePreviousYearQuestion";
import UpdatePreviousYearDocument from "UpdateViews/UpdatePreviousYearDocument";
import BulkImport from "AddViews/BulkImport";
import AIQuestions from "AddViews/AIQuestions";
import CreateTestSeries from "AddViews/CreateTestSeries";
import CreateMockTestSeries from "AddViews/CreateMockTestSeries";
import CreateLiveTest from "AddViews/CreateLiveTest";
import AllotQuestions from "AddViews/AllotQuestions";
import UpdateMockTestSeries from "UpdateViews/UpdateMockTestSeries";
import UpdateScheduledTestSeries from "UpdateViews/UpdateScheduledTestSeries";
import ImportMockTestSeriesQuestions from "AddViews/ImportMockTestSeriesQuestions";
import ImportLiveTestQuestions from "AddViews/ImportLiveTestQuestions";
import UpdateLiveTest from "UpdateViews/UpdateLiveTest";
import AddBlogs from "AddViews/AddBlogs";
import UpdateBlogs from "UpdateViews/UpdateBlogs";
import AddNotifications from "AddViews/AddNotifications";
import AddNews from "AddViews/AddNews";
import UpdateNews from "UpdateViews/UpdateNews";
import AddGallery from "AddViews/AddGallery";
import UpdateGallery from "UpdateViews/UpdateGallery";
import TestSeriesLeaderboard from "./Views/TestSeriesLeaderboard";
import LiveTestLeaderboard from "./Views/LiveTestLeaderboard";
import UserAttemptReports from "./Views/UserAttemptReports";
import UserPracticeTests from "./Views/UserPracticeTests";
import SubscriptionPlanEditor from "./Views/SubscriptionPlanEditor";
import SupportTicketReply from "./Views/SupportTicketReply";

function Main() {
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <>
      <Sidenav brandName="AgriQuiz Control" routes={routes} />
      <Routes>
        {getRoutes(routes)}
        <Route
          path="/support-issues/:ticketId"
          element={
            <ProtectedRoute
              element={<SupportTicketReply />}
              allowedRoles={["superadmin", "admin"]}
            />
          }
        />
        <Route
          path="/addNewJob"
          element={<ProtectedRoute element={<AddNewJob />} allowedRoles={["superadmin", "hr"]} />}
        />
        <Route
          path="/updateJob/:id"
          element={<ProtectedRoute element={<UpdateJob />} allowedRoles={["superadmin", "hr"]} />}
        />
        <Route
          path="/jobApplicants/:id"
          element={
            <ProtectedRoute
              element={<JobWiseApplicants />}
              allowedRoles={["superadmin", "hr", "manager"]}
            />
          }
        />
        <Route
          path="/applicant-details/:id"
          element={
            <ProtectedRoute
              element={<ApplicantProfile />}
              allowedRoles={["superadmin", "hr", "manager"]}
            />
          }
        />
        <Route
          path="/addtestimonials"
          element={<ProtectedRoute element={<AddNewTestimonial />} allowedRoles={["superadmin"]} />}
        />
        <Route
          path="/updateTestimonial/:id"
          element={
            <ProtectedRoute element={<UpdateTestimonials />} allowedRoles={["superadmin"]} />
          }
        />
        <Route
          path="/addsubject"
          element={
            <ProtectedRoute
              element={<AddCareer />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/addexam"
          element={
            <ProtectedRoute
              element={<AddExam />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/addyear"
          element={
            <ProtectedRoute
              element={<AddYear />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/add-exam-list"
          element={
            <ProtectedRoute
              element={<AddExamList />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/add-exam-list-set"
          element={
            <ProtectedRoute
              element={<AddExamListSet />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/auto-create-exam-list-sets"
          element={
            <ProtectedRoute
              element={<AutoCreateExamListSets />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/updatesubject/:id"
          element={
            <ProtectedRoute
              element={<UpdateCareer />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/updateexam/:id"
          element={
            <ProtectedRoute
              element={<UpdateExam />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/updateyear/:id"
          element={
            <ProtectedRoute
              element={<UpdateYear />}
              allowedRoles={["superadmin", "question_creater"]}
            />
          }
        />
        <Route
          path="/update-exam-list/:id"
          element={
            <ProtectedRoute
              element={<UpdateExamList />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/update-exam-list-set/:id"
          element={
            <ProtectedRoute
              element={<UpdateExamListSet />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/addTopic"
          element={
            <ProtectedRoute
              element={<AddTopics />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/updateTopic/:id"
          element={
            <ProtectedRoute
              element={<UpdateTopics />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/addLevel"
          element={
            <ProtectedRoute
              element={<AddLevels />}
              allowedRoles={["superadmin", "question_creater", "teacher"]}
            />
          }
        />
        <Route
          path="/add-ar-level"
          element={
            <ProtectedRoute
              element={<AddArLevels />}
              allowedRoles={["superadmin", "question_creater", "teacher"]}
            />
          }
        />
        <Route
          path="/updatelevel/:id"
          element={
            <ProtectedRoute
              element={<UpdateLevels />}
              allowedRoles={["superadmin", "question_creater", "teacher"]}
            />
          }
        />
        <Route
          path="/update-ar-level/:id"
          element={
            <ProtectedRoute
              element={<UpdateArLevels />}
              allowedRoles={["superadmin", "question_creater", "teacher"]}
            />
          }
        />
        <Route
          path="/level-questions/:id"
          element={
            <ProtectedRoute
              element={<LevelQuestions />}
              allowedRoles={["superadmin", "teacher", "question_creater", "question_approver"]}
            />
          }
        />
        <Route
          path="/user-details/:id"
          element={
            <ProtectedRoute
              element={<UserDetails />}
              allowedRoles={[
                "superadmin",
                "manager",
                "teacher",
                "question_creater",
                "question_approver",
              ]}
            />
          }
        />
        <Route
          path="/user-details/:id/feedback"
          element={
            <ProtectedRoute
              element={<UserFeedback />}
              allowedRoles={[
                "superadmin",
                "manager",
                "teacher",
                "question_creater",
                "question_approver",
              ]}
            />
          }
        />
        <Route
          path="/user-practice-tests/:id"
          element={
            <ProtectedRoute
              element={<UserPracticeTests />}
              allowedRoles={[
                "superadmin",
                "manager",
                "teacher",
                "question_creater",
                "question_approver",
              ]}
            />
          }
        />
        <Route
          path="/user-attempt-reports"
          element={
            <ProtectedRoute
              element={<UserAttemptReports />}
              allowedRoles={[
                "superadmin",
                "manager",
                "teacher",
                "question_creater",
                "question_approver",
                "test_series_manager",
              ]}
            />
          }
        />
        <Route
          path="/subscriptions/create"
          element={
            <ProtectedRoute
              element={<SubscriptionPlanEditor />}
              allowedRoles={["superadmin"]}
            />
          }
        />
        <Route
          path="/subscriptions/:id/edit"
          element={
            <ProtectedRoute
              element={<SubscriptionPlanEditor />}
              allowedRoles={["superadmin"]}
            />
          }
        />
        <Route
          path="/addCollege"
          element={
            <ProtectedRoute element={<AddUniversity />} allowedRoles={["superadmin", "admin"]} />
          }
        />
        <Route
          path="/addEmployee"
          element={
            <ProtectedRoute element={<AddEmployee />} allowedRoles={["superadmin", "admin"]} />
          }
        />
        <Route
          path="/updateCollege/:id"
          element={
            <ProtectedRoute
              element={<UpdateUniversity />}
              allowedRoles={["superadmin", "admin"]}
            />
          }
        />
        <Route
          path="/updateEmployee/:id"
          element={
            <ProtectedRoute
              element={<UpdateEmployee />}
              allowedRoles={["superadmin", "admin"]}
            />
          }
        />
        <Route
          path="/addQuestion"
          element={
            <ProtectedRoute
              element={<AddQuestions />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/approveQuestions/:id"
          element={
            <ProtectedRoute
              element={<ApproveQuestions approve={true} />}
              allowedRoles={["superadmin", "question_approver"]}
            />
          }
        />
        <Route
          path="/updateQuestion/:id"
          element={
            <ProtectedRoute
              element={<UpdateQuestions />}
              allowedRoles={["superadmin", "teacher", "question_creater", "question_approver"]}
            />
          }
        />
        <Route
          path="/update-ar-question/:id"
          element={
            <ProtectedRoute
              element={<UpdateArQuestion />}
              allowedRoles={["superadmin", "teacher", "question_creater", "question_approver"]}
            />
          }
        />
        <Route
          path="/add-agriboost"
          element={
            <ProtectedRoute
              element={<AddAgriBoost />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/add-bulk-agriboost"
          element={
            <ProtectedRoute
              element={<BulkImportAgriBoost />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/add-previous-year-question"
          element={
            <ProtectedRoute
              element={<AddPreviousYearQuestion />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/update-agriboost/:id"
          element={
            <ProtectedRoute
              element={<UpdateAgriBoost />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/update-previous-year-question/:id"
          element={
            <ProtectedRoute
              element={<UpdatePreviousYearQuestion />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/add-previous-year-document"
          element={
            <ProtectedRoute
              element={<AddPreviousYearDocument />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/update-previous-year-document/:id"
          element={
            <ProtectedRoute
              element={<UpdatePreviousYearDocument />}
              allowedRoles={["superadmin", "teacher", "question_creater"]}
            />
          }
        />
        <Route
          path="/add-bulk-question"
          element={
            <ProtectedRoute
              element={<BulkImport />}
              allowedRoles={["superadmin", "teacher", "question_creater", "question_approver"]}
            />
          }
        />
        <Route
          path="/add-bulk-previous-year-question"
          element={
            <ProtectedRoute
              element={<BulkImportPreviousYearQuestions />}
              allowedRoles={["superadmin", "teacher", "question_creater", "question_approver"]}
            />
          }
        />
        <Route
          path="/add-bulk-ar-question"
          element={
            <ProtectedRoute
              element={<BulkImportArQuestions />}
              allowedRoles={["superadmin", "teacher", "question_creater", "question_approver"]}
            />
          }
        />
        <Route
          path="/add-ai-question"
          element={
            <ProtectedRoute
              element={<AIQuestions />}
              allowedRoles={["superadmin", "teacher", "question_creater", "question_approver"]}
            />
          }
        />
        <Route
          path="/addTestseries"
          element={
            <ProtectedRoute
              element={<CreateTestSeries />}
              allowedRoles={["superadmin", "test_series_manager", "question_approver"]}
            />
          }
        />
        <Route
          path="/addMockTestseries"
          element={
            <ProtectedRoute
              element={<CreateMockTestSeries />}
              allowedRoles={["superadmin", "test_series_manager", "question_approver"]}
            />
          }
        />
        <Route
          path="/addLiveTest"
          element={
            <ProtectedRoute
              element={<CreateLiveTest />}
              allowedRoles={["superadmin", "test_series_manager", "question_approver"]}
            />
          }
        />
        <Route
          path="/allot-questions/:id"
          element={
            <ProtectedRoute
              element={<AllotQuestions />}
              allowedRoles={["superadmin", "test_series_manager"]}
            />
          }
        />
        <Route
          path="/update-live-test/:id"
          element={
            <ProtectedRoute
              element={<UpdateLiveTest />}
              allowedRoles={["superadmin", "test_series_manager", "question_approver"]}
            />
          }
        />
        <Route
          path="/update-mock-testseries/:id"
          element={
            <ProtectedRoute
              element={<UpdateMockTestSeries />}
              allowedRoles={["superadmin", "test_series_manager", "question_approver"]}
            />
          }
        />
        <Route
          path="/import-live-test-questions/:id"
          element={
            <ProtectedRoute
              element={<ImportLiveTestQuestions />}
              allowedRoles={["superadmin", "test_series_manager", "question_approver"]}
            />
          }
        />
        <Route
          path="/update-scheduled-testseries/:id"
          element={
            <ProtectedRoute
              element={<UpdateScheduledTestSeries />}
              allowedRoles={["superadmin", "test_series_manager", "question_approver"]}
            />
          }
        />
        <Route
          path="/testseries-leaderboard/:id"
          element={
            <ProtectedRoute
              element={<TestSeriesLeaderboard />}
              allowedRoles={["superadmin", "test_series_manager", "question_approver"]}
            />
          }
        />
        <Route
          path="/live-test-leaderboard/:id"
          element={
            <ProtectedRoute
              element={<LiveTestLeaderboard />}
              allowedRoles={["superadmin", "test_series_manager", "question_approver"]}
            />
          }
        />
        <Route
          path="/import-mock-test-questions/:id"
          element={
            <ProtectedRoute
              element={<ImportMockTestSeriesQuestions />}
              allowedRoles={["superadmin", "test_series_manager", "question_approver"]}
            />
          }
        />
        <Route
          path="/addnewblogs"
          element={
            <ProtectedRoute
              element={<AddBlogs />}
              allowedRoles={["superadmin", "marketing_team"]}
            />
          }
        />
        <Route
          path="/update-blog/:id"
          element={
            <ProtectedRoute
              element={<UpdateBlogs />}
              allowedRoles={["superadmin", "marketing_team"]}
            />
          }
        />
        <Route
          path="/addgallery"
          element={
            <ProtectedRoute
              element={<AddGallery />}
              allowedRoles={["superadmin", "marketing_team"]}
            />
          }
        />
        <Route
          path="/update-gallery/:id"
          element={
            <ProtectedRoute
              element={<UpdateGallery />}
              allowedRoles={["superadmin", "marketing_team"]}
            />
          }
        />
        <Route
          path="/addnews"
          element={
            <ProtectedRoute
              element={<AddNews />}
              allowedRoles={["superadmin", "marketing_team"]}
            />
          }
        />
        <Route
          path="/update-news/:id"
          element={
            <ProtectedRoute
              element={<UpdateNews />}
              allowedRoles={["superadmin", "marketing_team"]}
            />
          }
        />
        <Route
          path="/addNotification"
          element={<ProtectedRoute element={<AddNotifications />} allowedRoles={["superadmin"]} />}
        />
      </Routes>
    </>
  );
}

export default Main;
